import { TaxCalculationType } from '@commenda/api/sales-tax/types';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';
import { useState } from 'react';
import { RadioCardKS } from '../../../components';

interface TaxCalculationSettingModalProps {
  isShown: boolean;
  onClose: () => void;
  onSave: (type: TaxCalculationType) => void;
  defaultType?: TaxCalculationType;
}

export const TaxCalculationSettingModal = ({
  isShown,
  onClose,
  onSave,
  defaultType = TaxCalculationType.TAX_EXCLUSIVE,
}: TaxCalculationSettingModalProps) => {
  const [calculationType, setCalculationType] =
    useState<TaxCalculationType>(defaultType);

  const handleSave = () => {
    onSave(calculationType);
    onClose();
  };

  return (
    <Dialog open={isShown} onOpenChange={onClose}>
      <DialogContent
        className="min-w-[600px]"
        hideCloseIcon
        preventCloseOnOutsideClick
      >
        <DialogHeader className="flex items-start flex-col gap-1 border-b-0 ">
          <DialogTitle className="flex-start">
            Tax Calculation Setting
          </DialogTitle>
          <p className="txt-small-regular text-text-tertiary">
            Select how tax should be calculated for transactions imported via
            CSV. This setting will be your default until you change it.
          </p>
        </DialogHeader>

        <div className="flex flex-col gap-3 px-6 pb-8">
          <RadioCardKS
            heading="Tax exclusive (Recommended)"
            description="Transaction amounts exclude tax. Taxes will be imported in a separate column."
            onClick={() => setCalculationType(TaxCalculationType.TAX_EXCLUSIVE)}
            isActive={calculationType === TaxCalculationType.TAX_EXCLUSIVE}
          />
          <RadioCardKS
            heading="Tax inclusive"
            description="Transaction amounts include tax. Taxes will be calculated by Commenda from transaction amount."
            onClick={() => setCalculationType(TaxCalculationType.TAX_INCLUSIVE)}
            isActive={calculationType === TaxCalculationType.TAX_INCLUSIVE}
          />
        </div>

        <DialogFooter>
          <Button variant="secondary" size="sm" onClick={onClose}>
            Cancel
          </Button>
          <Button size="sm" onClick={handleSave}>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
